import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CloudbedsService } from '@app/services/cloudbeds.service';
import { environment } from '@env/environment';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import  moment  from 'moment';

@Component({
  selector: 'app-modal-charges',
  templateUrl: './modal-charges.component.html',
  styleUrls: ['./modal-charges.component.scss'],
})
export class ModalChargesComponent implements OnInit {
  reservation: any;
  roomSelected: any;
  public environment = environment;
  constructor(
    public storage: Storage,
    public router: Router,
    private modalCtrlr: ModalController,) { }

  async ngOnInit() {
    this.reservation = await this.storage.get('reservationData');
    this.roomSelected = await this.storage.get('roomSelected');
    console.log(this.reservation)
    console.log(this.roomSelected)
  }

  calculateNights(): number {
    if (!this.roomSelected) return;
    // Parseamos las fechas usando moment
    const start = moment(this.roomSelected.startDate, 'YYYY-MM-DD');
    const end = moment(this.roomSelected.endDate, 'YYYY-MM-DD');

    // Verificamos que las fechas sean válidas
    if (!start.isValid() || !end.isValid()) {
      // throw new Error('Las fechas proporcionadas no son válidas.');
    }

    // Calculamos la diferencia en días
    const duration = moment.duration(end.diff(start));
    const nights = duration.asDays();
    console.log(nights > 0 ? +nights : 0)
    // Si la diferencia es negativa, devolvemos 0 (por ejemplo, cuando la fecha de inicio es después de la fecha de finalización)
    return nights > 0 ? +nights : 0;
  }

  changePayments(){
    this.modalCtrlr.dismiss();
    console.log(true);
    this.router.navigate(['checkin/payment/cards'])
  }

  go(){
    this.modalCtrlr.dismiss();
  }
}
